import React from 'react';
import BreadcrumbList from '@modules/Sellers/Stock/components/Breadcrumb';
import { Card } from 'antd';
import ReturnDeliveryList from '@modules/Warehouse/Delivery/pages/ReturnDeliveryList';

const breadcrumbList = [
  {
    tittle: 'Delivery',
    url: ''
  },
  {
    tittle: 'Return List',
    url: ''
  }
];

const ReturnDelivery = () => {

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <ReturnDeliveryList />
        </Card>
      </div>
    </>
  );
}

export default ReturnDelivery;